/* ============================================================
   VEYLO — quick add
   Product cards for multi-option products show "Add to Cart".
   Clicking opens a small panel where the shopper picks the
   variant, so the label is honest and the choice is deliberate.
   Falls back to the product page when JavaScript is unavailable.
   ============================================================ */
(function () {
  'use strict';

  var overlay = null;
  var state = { data: null, selected: [], trigger: null };

  function buildOverlay() {
    if (overlay) return overlay;

    overlay = document.createElement('div');
    overlay.className = 'veylo-qa-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML =
      '<div class="veylo-qa">' +
      '<button class="veylo-qa__close" type="button" aria-label="Close">&times;</button>' +
      '<div class="veylo-qa__head">' +
      '<img class="veylo-qa__thumb" alt="" data-qa-thumb>' +
      '<div><h2 class="veylo-qa__title" data-qa-title></h2>' +
      '<p class="veylo-qa__price" data-qa-price></p></div>' +
      '</div>' +
      '<div data-qa-groups></div>' +
      '<button class="veylo-qa__confirm" type="button" data-qa-confirm>Add to Cart</button>' +
      '<p class="veylo-qa__error" data-qa-error hidden></p>' +
      '<p class="veylo-qa__link">or <a data-qa-link>see full product details</a></p>' +
      '</div>';

    document.body.appendChild(overlay);

    overlay.querySelector('.veylo-qa__close').addEventListener('click', close);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });
    overlay.querySelector('[data-qa-confirm]').addEventListener('click', confirmAdd);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });

    return overlay;
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (state.trigger) state.trigger.focus();
    state.data = null;
  }

  function matchVariant(selected) {
    if (!state.data) return null;
    var variants = state.data.variants;
    for (var i = 0; i < variants.length; i++) {
      var ok = true;
      for (var n = 0; n < selected.length; n++) {
        if (selected[n] !== null && variants[i].options[n] !== selected[n]) { ok = false; break; }
      }
      if (ok) return variants[i];
    }
    return null;
  }

  function renderGroups() {
    var host = overlay.querySelector('[data-qa-groups]');
    host.innerHTML = '';

    state.data.options.forEach(function (opt, gi) {
      var group = document.createElement('div');
      group.className = 'veylo-qa__group';

      var label = document.createElement('span');
      label.className = 'veylo-qa__label';
      label.appendChild(document.createTextNode(opt.name + ': '));
      var chosen = document.createElement('b');
      chosen.textContent = state.selected[gi] || '—';
      label.appendChild(chosen);
      group.appendChild(label);

      var values = document.createElement('div');
      values.className = 'veylo-qa__values';
      values.setAttribute('role', 'group');
      values.setAttribute('aria-label', opt.name);

      opt.values.forEach(function (value) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'veylo-qa__btn';
        btn.textContent = value;
        btn.setAttribute('aria-pressed', state.selected[gi] === value ? 'true' : 'false');
        btn.addEventListener('click', function () {
          state.selected[gi] = value;
          renderGroups();
          syncFooter();
        });
        values.appendChild(btn);
      });

      group.appendChild(values);
      host.appendChild(group);
    });

    var groups = host.querySelectorAll('.veylo-qa__group');
    Array.prototype.forEach.call(groups, function (group, gi) {
      var buttons = group.querySelectorAll('.veylo-qa__btn');
      Array.prototype.forEach.call(buttons, function (btn) {
        var probe = state.selected.slice();
        probe[gi] = btn.textContent;
        var v = matchVariant(probe);
        btn.setAttribute('data-unavailable', v && v.available ? 'false' : 'true');
      });
    });
  }

  function syncFooter() {
    var variant = matchVariant(state.selected);
    var confirm = overlay.querySelector('[data-qa-confirm]');
    var price = overlay.querySelector('[data-qa-price]');

    if (variant) {
      price.innerHTML = variant.price + (variant.compare ? ' <s>' + variant.compare + '</s>' : '');
    }

    var ok = !!(variant && variant.available);
    confirm.disabled = !ok;
    confirm.textContent = variant ? (variant.available ? 'Add to Cart' : 'Sold Out') : 'Choose an option';
  }

  function open(trigger) {
    var holder = trigger.closest('[data-veylo-qa-card]');
    if (!holder) return;

    var raw = holder.querySelector('[data-veylo-qa-data]');
    if (!raw) return;

    try {
      state.data = JSON.parse(raw.textContent);
    } catch (e) {
      window.location.href = trigger.getAttribute('href') || '#';
      return;
    }

    state.trigger = trigger;
    buildOverlay();

    var first = null;
    for (var i = 0; i < state.data.variants.length; i++) {
      if (state.data.variants[i].available) { first = state.data.variants[i]; break; }
    }
    state.selected = first
      ? first.options.slice(0, state.data.options.length)
      : state.data.options.map(function () { return null; });

    overlay.querySelector('[data-qa-title]').textContent = state.data.title;
    var thumb = overlay.querySelector('[data-qa-thumb]');
    if (state.data.image) {
      thumb.src = state.data.image;
      thumb.hidden = false;
    } else {
      thumb.hidden = true;
    }
    overlay.querySelector('[data-qa-link]').href = state.data.url;
    overlay.querySelector('[data-qa-error]').hidden = true;

    renderGroups();
    syncFooter();

    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    overlay.querySelector('[data-qa-confirm]').focus();
  }

  function confirmAdd() {
    var variant = matchVariant(state.selected);
    if (!variant || !variant.available) return;

    var btn = overlay.querySelector('[data-qa-confirm]');
    var err = overlay.querySelector('[data-qa-error]');
    var original = btn.textContent;

    btn.disabled = true;
    btn.textContent = 'Adding…';
    err.hidden = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variant.id, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        btn.disabled = false;
        btn.textContent = original;

        if (data.status) {
          err.textContent = data.description || data.message || 'Could not add to cart.';
          err.hidden = false;
          return;
        }

        close();

        var drawer = document.querySelector('cart-drawer');
        if (drawer && data.sections && typeof drawer.renderContents === 'function') {
          try { drawer.renderContents(data); return; } catch (e) { /* fall through */ }
        }
        window.location.href = '/cart';
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = original;
        err.textContent = 'Something went wrong. Please try again.';
        err.hidden = false;
      });
  }

  function bind() {
    var triggers = document.querySelectorAll('[data-veylo-qa-open]:not([data-qa-bound])');
    Array.prototype.forEach.call(triggers, function (t) {
      t.setAttribute('data-qa-bound', '1');
      t.addEventListener('click', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        open(t);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', bind);

  if ('MutationObserver' in window) {
    new MutationObserver(function () { bind(); }).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
